import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { FluentProvider, webLightTheme, webDarkTheme, teamsLightTheme, teamsDarkTheme } from "@fluentui/react-components";

// Import centralized styles
import "./styles/index.css";

import App from "./App";
import { telemetryService } from "./services/telemetry.service";

// Fonction pour déterminer le thème approprié
const getTheme = (themeName: string) => {
  switch (themeName) {
    case 'dark':
      return webDarkTheme;
    case 'contrast':
      return webDarkTheme; // Utiliser le thème sombre pour le contraste
    case 'teamsDark':
      return teamsDarkTheme;
    case 'teamsLight':
      return teamsLightTheme;
    default:
      return webLightTheme;
  }
};

// Composant principal avec le fournisseur de thème Fluent UI
const ThemedApp = () => {
  // Récupérer le thème depuis l'attribut data-theme ou utiliser le thème par défaut
  const [theme, setTheme] = React.useState(webLightTheme);
  
  React.useEffect(() => {
    // Observer les changements de thème
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const themeClass = document.documentElement.className;
          let themeName = 'default';
          
          if (themeClass.includes('theme-dark')) themeName = 'dark';
          else if (themeClass.includes('theme-contrast')) themeName = 'contrast';
          
          setTheme(getTheme(themeName));
        }
      });
    });
    
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    return () => observer.disconnect();
  }, []);
  
  return (
    <FluentProvider theme={theme}>
      <App />
    </FluentProvider>
  );
};

// Initialize Telemetry Service (calls back-end routes, not PostHog directly)
const isDevelopment = import.meta.env.MODE === 'development';

telemetryService.initialize(isDevelopment).catch((error) => {
  console.error('[Telemetry] Failed to initialize telemetry service:', error);
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemedApp />
  </StrictMode>
);
